import { BaseClient } from '../client';
import { dashboardMock } from './dashboard.mocks';
import { TDashboard } from './dashboard.types';

interface getDashboardProps {
	id: number;
}

export const getDashboard = async ({ id }: getDashboardProps) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return dashboardMock;
	// }

	try {
		const response = await BaseClient.get<TDashboard>(`/Revendas/GetDashBoardRevenda/${id}`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
